import { magazineListingPaths } from '@schuelerhilfe/shared/src/seo/magazinePaths';

// Routes this project already owns, exempt from the POC "off-page links
// continue on the live site" mechanism (SH-275, spec 10.01.04). Both layers of
// that mechanism consult this list — `toLiveHref()` (link rewriting) and
// `pocLiveSiteRedirect()` in `proxy.ts` (referer-based 307) — because patching
// only one still leaves the other sending the visitor to production.
//
// Entries are locale-less path prefixes with no trailing slash.
const STATIC_POC_OWNED_PATH_PREFIXES = ['/standorte/suche'];

// Owned **below** the prefix only. `/angebote/{slug}` is the Offer Locations
// family (SH-512, spec 10.02.12); the bare `/angebote/` is still the live
// site's own offer page (`/angebote/?tx_schuelerhilfetheme_offers…`), which
// offer CTAs link to, and must keep leaving for the live site.
const POC_OWNED_CHILD_PATH_PREFIXES = ['/angebote'];

/** `/fr/standorte/suche/` → `/standorte/suche/`; anything else unchanged. */
function stripLocalePrefix(pathname: string): string {
  const withoutLocale = pathname.replace(/^\/[a-z]{2}(?=\/|$)/i, '');
  return withoutLocale === '' ? '/' : withoutLocale;
}

// The whole magazine family, every brand's root at once: one build image
// serves all brands, and the active one is server-only knowledge that the
// client-side `Link` cannot reach. Derived from the shared path map, so a
// brand or locale added there is exempt without an edit here.
const POC_OWNED_PATH_PREFIXES = [
  ...new Set([
    ...STATIC_POC_OWNED_PATH_PREFIXES,
    ...magazineListingPaths().map((path) =>
      stripLocalePrefix(path.replace(/\/+$/, '')),
    ),
  ]),
];

/**
 * True for a path this project serves itself — with or without a trailing
 * slash, with or without a locale prefix, and including any query string,
 * which `toLiveHref()` receives as part of the href.
 */
export function isPocOwnedPath(pathnameOrHref: string): boolean {
  const pathname = stripLocalePrefix(
    pathnameOrHref.split(/[?#]/)[0].replace(/\/+$/, '') || '/',
  ).toLowerCase();

  return (
    POC_OWNED_PATH_PREFIXES.some(
      (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
    ) ||
    POC_OWNED_CHILD_PATH_PREFIXES.some((prefix) =>
      pathname.startsWith(`${prefix}/`),
    )
  );
}
